<template>
	<v-app-bar
		app
		color="primary"
		dark
		height="50"
		elevation="1"
	>
        <v-app-bar-nav-icon @click="$emit('drawer')" class="me-2"></v-app-bar-nav-icon>
        <h1 class="text-uppercase text-body-1">{{$T(`routes.${$route.meta.i18nTranslateKey}`)}}</h1>
		<v-spacer/>

		<v-btn
			small
			text
			@click="changeI18nLang($i18n.locale !== 'ar' ? 'ar' : 'en')"
		>
			{{$i18n.locale !== 'ar' ? 'العربية' : 'English'}}
			<v-icon size="18" class="ms-2">mdi-earth</v-icon>
		</v-btn>

		<v-badge
			v-if="useNotifications"
			id="notification-badge"
			color="red"
			overlap
			:content="notifications.length"
			:value="notifications.length"
			:offset-x="12"
			:offset-y="12"
		>
			<v-btn
				small
				icon
				class="ms-1"
				:to="{ name: 'notifications' }"
			>
				<v-icon size="18">mdi-bell{{notifications.length ? '-ring' : ''}}</v-icon>
			</v-btn>
		</v-badge>
		
		<!-- loading line -->
		<v-progress-linear
			indeterminate
			absolute
			bottom
			:active="loading"
			height="4"
			background-color="primary"
			color="secondary lighten-1"
		></v-progress-linear>
    </v-app-bar>
</template>

<script>
import { changeI18nLang } from '@/i18n/i18n'
import { mapState } from 'vuex'
import { useNotifications } from '@/configs/general.configs'
export default {
	props: [
		'loading'
	],

	data() {
		return {
			useNotifications
		}
	},

	computed: {
		...mapState({
			notifications: state => state.notifications.notifications
		})
	},

	methods: {
		changeI18nLang
	}
}
</script>

<style lang="scss">
#notification-badge {
	.v-badge__badge {
		display: flex;
		justify-content: center;
		align-items: center;
		min-width: 14px;
		width: 14px;
		height: 14px;
		padding: 0;
	}
}
</style>